module.exports = __webpack_public_path__ + "static/media/Makeup03.ddc15c7e.jpeg";